// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupSidebar_container__3G3-q"};